module.exports = __webpack_public_path__ + "media/图1-2动画.a426f942.mp4";